import logo from './logo.svg'
import './App.css'
import Home from './pages/home'
import ServiceScrollSection from './pages/ServiceScrollSection'
import TechDesign from './pages/TechDesign'

function App() {
  //return <TechDesign />
  return <Home />
  //return <ServiceScrollSection />
}

export default App
